import { useState } from "react";
import Button from '@/components/Button';
import axios from "axios";
import Switch from '/src/components/Switch';
import { html } from '@/utils/Format';
import { saveUser } from "@/utils/User";
import { useSession } from '@toolpad/core/useSession';
import { getErrorMessage } from '@/utils/Errors';

export default function Legal({t,language,user,setUser,router,token,apiUrl,sendMessage,handleLogin}){

	const session = useSession();

	const [ accept, setAccept ] = useState(false);

	const handleAccept = (e) => {
        //const name = e.target.name;
        const value = e.target.checked;     
        setAccept(value);
    }
	// accept conditions
	const handleSubmit = () => {

		if(!accept){
			sendMessage(t('legal.errors.notaccepted'),'error');
		}
		else{
			
			const apiPath = '/legal';

			const config = {
	            headers: { Authorization: `Bearer ${token}` } 
	        };

	        const acceptInt = accept ? 1 : 0;

	        const send = {
	            language: language,
	            companyuser: user?.company,
	            accept: acceptInt
	        };

            var errorMessage = t('legal.error');
            const url = apiUrl+apiPath;
            
            axios.post(url,send,config)
            .then(function (response) {
                    
                if(response?.data){
              
                    var responseData = response.data;

                    if(responseData?.result){              
                        // update user                       
				        user.legal = acceptInt;
				        saveUser(user);
				        session?.setUser(user);
				        
				        //window.location.reload();
				        setUser(user);					        

				        // to force "refresh" and remove the warning
				        // just in case we are already on /				        
				        if(router.pathname === '/'){
				        	router.navigate('/profile');
				    	}
				    	else{
				    		router.navigate('/');
				    	}
                    } 
                    else{

                    	if(responseData?.status && responseData.status === 401){
	                        handleLogin();
	                    }
	                    else{ 

	                        // check error message
	                        if(responseData?.data?.reasons){                            
                                const reasons = responseData?.data?.reasons;
                                errorMessage = getErrorMessage(t,'login',reasons,false,false);
                            }
	                        
	                        sendMessage(errorMessage,'error');   
	                    }                     
                    }
                }
                else{
                    sendMessage(errorMessage,'error');   
                }
            })
            .catch(function (error){
                
                if(error?.status && error.status === 401){
                    handleLogin();                        
                }
                else{                        
                    sendMessage(t('legal.error'),'error');
                }
            });
		}
	}
	
 	return (
    	<div id='legal-page'>
    		<div className='text-center text-2xl font-bold app-color mb-8 border-b app-border-color-gradient'>
    			{t('legal.policy.title')}
    		</div>
    		<div dangerouslySetInnerHTML={{__html: html(t('legal.policy.message'))}}></div>
    		<div className='mt-8'>
		        <Switch                                                                
	                name='legal'
	                checked={accept}
	                label={t('legal.check')}
	                onChange={handleAccept}
                    fontWeight={accept && 'bold'}
	            />
	        </div>
	        <div className='text-center mt-8 mb-16'>		            		
          		<Button
            		type="accept"
            		text={t("legal.button")}
            		onClick={handleSubmit}
            		disabled={!accept}
          		/>			              	
        	</div>
    	</div>
  	)
}
